module.exports = __webpack_public_path__ + "img/tooltip-bg.8a4109a3.png";